import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/admin/refund/list' // 광고목록 조회

const fetchKey = (userId, page, maxData) =>
	`${M_KEY}/${userId}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}`;

export function useAdminRefundDetailList(userId, page, maxData) {
	const { data: token } = useToken();

	const KEY = fetchKey(userId, page, maxData);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { adminRefundDetailList: data?.list, mutateAdminRefundDetailList: mutate, total: data?.total };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Admin Refund Detail List:', error);
		return { list: [], total: 0 };
	}
}